import { createFloor01 } from '../content/floors/floor01';
import { getCurrentRoom } from '../domain/dungeon/roomRules';
import { createInitialPlayer } from '../domain/game/createPlayer';
import { modeFromRoom } from '../domain/game/modeFromRoom';
import type { DungeonFloor, RoomOption } from '../domain/game/types';
import { readSaveFromStorage } from '../domain/save/saveGame';
import type { GameData } from './types';

export function createInitialData(): GameData {
  const dungeon = createFloor01();
  return {
    dungeon,
    mode: modeFromRoom(getCurrentRoom(dungeon)),
    player: createInitialPlayer(),
    combat: null,
    previousRoomId: null,
    lastMessage: 'Phân bổ chỉ số · mang vật phẩm combat · Pha Lê dùng để lưu.',
    hasSave: readSaveFromStorage() !== null,
  };
}

export const MOVE_FAIL_MESSAGE: Record<string, string> = {
  'cannot-leave': 'Phòng này yêu cầu xử lý sự kiện trước khi rời đi.',
  'not-connected': 'Chỉ có thể đi sang phòng liền kề có lối nối.',
  'same-room': 'Bạn đang ở phòng này.',
  dead: 'Bạn đã ngã xuống…',
  'unknown-room': 'Không tìm thấy phòng.',
};

export function successfulMovePatch(
  fromRoomId: string,
  dungeon: DungeonFloor,
): Pick<GameData, 'dungeon' | 'previousRoomId' | 'mode' | 'combat' | 'lastMessage'> {
  const room = getCurrentRoom(dungeon);
  return {
    dungeon,
    previousRoomId: fromRoomId,
    mode: modeFromRoom(room),
    combat: null,
    lastMessage: room ? `Đã tới: ${room.name}` : null,
  };
}

export function retreatToPrevious(
  floor: DungeonFloor,
  previousRoomId: string | null,
  currentRoomId: string,
): { floor: DungeonFloor; previousRoomId: string | null } {
  if (!previousRoomId || !floor.rooms[previousRoomId]) {
    return { floor, previousRoomId };
  }
  return {
    floor: { ...floor, playerRoomId: previousRoomId },
    previousRoomId: currentRoomId,
  };
}

export function enemyKeyFromOption(option: RoomOption): string {
  return (
    option.consequence.enemyId ??
    option.consequence.bossName ??
    option.consequence.monsterName ??
    'ambusher'
  );
}
